module.exports = __webpack_public_path__ + "img/pr-3.b77023bd.png";